"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/set-timeout"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _FlashContext = require("./FlashContext");

var FlashMessage = function FlashMessage(_ref) {
  var _context;

  var message = _ref.message,
      timeout = _ref.timeout;

  var _useFlash = (0, _FlashContext.useFlash)(),
      dismissMessage = _useFlash.dismissMessage,
      cycleMessage = _useFlash.cycleMessage;

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      classes = _useState2[0],
      setClasses = _useState2[1];

  (0, _react.useEffect)(function () {
    cycleMessage(message.id); // cycleMessage should not trigger update
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message.id]);
  (0, _react.useEffect)(function () {
    var fadeOutTimer;

    if (timeout) {
      fadeOutTimer = (0, _setTimeout2.default)(function () {
        setClasses('rw-slide-up');
      }, timeout);
    }

    return function () {
      return clearTimeout(fadeOutTimer);
    };
  }, [timeout]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _concat.default)(_context = "rw-flash-message ".concat(message.classes, " ")).call(_context, classes),
    "data-testid": "message"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "rw-flash-message-text"
  }, message.text), /*#__PURE__*/_react.default.createElement("div", {
    className: "rw-flash-message-dismiss",
    "data-testid": "dismiss",
    onClick: function onClick() {
      return dismissMessage(message.id);
    }
  }, "+"));
};

var Flash = function Flash(_ref2) {
  var timeout = _ref2.timeout;

  var _useFlash2 = (0, _FlashContext.useFlash)(),
      messages = _useFlash2.messages;

  if (!messages.length) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "rw-flash",
    "data-testid": "flash"
  }, (0, _map.default)(messages).call(messages, function (msg) {
    return /*#__PURE__*/_react.default.createElement(FlashMessage, {
      key: msg.id,
      message: msg,
      timeout: timeout
    });
  }));
};

var _default = Flash;
exports.default = _default;